import { LOAN_EXCEPTIONS_ACTION_TYPE } from '../types';

const initialState = {};

const replaceItem = (items, updated) => {
  if (!updated) {
    return items;
  }

  const next = [...items];
  const index = next.findIndex(item => item.id === updated.id);

  if (index === -1) {
    next.push(updated);

    return next;
  }

  next[index] = updated;

  return next;
};

const updateAcrossLoans = (state, exception) => {
  if (!exception) {
    return state;
  }

  const { loanId } = exception;

  if (!loanId) {
    return state;
  }

  return {
    ...state,
    [loanId]: replaceItem(state[loanId] || [], exception),
  };
};

const loanExceptionsByLoanReducer = (state = initialState, action) => {
  switch (action.type) {
    case LOAN_EXCEPTIONS_ACTION_TYPE.GET_FOR_LOAN:
      return {
        ...state,
        [action.meta.loanId]: action.payload || [],
      };

    case LOAN_EXCEPTIONS_ACTION_TYPE.CREATE:
    case LOAN_EXCEPTIONS_ACTION_TYPE.UPDATE:
    case LOAN_EXCEPTIONS_ACTION_TYPE.DECIDE:
    case LOAN_EXCEPTIONS_ACTION_TYPE.WITHDRAW:
      return updateAcrossLoans(state, action.payload);

    case LOAN_EXCEPTIONS_ACTION_TYPE.CLEAR:
      return initialState;

    default:
      return state;
  }
};

export default loanExceptionsByLoanReducer;
